import { useTranslation } from 'react-i18next';

import ArrowRightShape from '@/components/common/svg/shapes/ArrowRightShape.tsx';
import {
  blockContainer,
  iconWrapperStyle
} from '@/components/ProfileData/Blocks/styles.ts';
import RulerShape from '@/components/common/svg/shapes/RulerShape.tsx';
import { useProfileStore } from '@/store/useProfileStore.ts';

interface HeightBlockProps {
  onOpen: () => void;
}

export const HeightBlock = ({ onOpen }: HeightBlockProps) => {
  const { t } = useTranslation();
  const { aboutMe } = useProfileStore();

  return (
    <div style={blockContainer} onClick={onOpen}>
      <div style={iconWrapperStyle}>
        <RulerShape width={20} height={20} fillColor="#1A1A1A" />
      </div>
      <span
        style={{
          flexGrow: 1,
          textAlign: 'left',
          fontSize: '15px',
          fontWeight: '400'
        }}
      >
        {aboutMe?.profile.height_cm && aboutMe?.profile.height_cm !== 0
          ? `${aboutMe?.profile.height_cm} ${t('height_cm')}`
          : t('add_height_title')}
      </span>
      <ArrowRightShape width={14} height={14} fillColor="#C8C8CB" />
    </div>
  );
};
